import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import bag from "../assets/images/loading_product_icon_bag.png";
import cloth from "../assets/images/loading_product_icon_cloth.png";
import cos from "../assets/images/loading_product_icon_cos.png";
import shoe from "../assets/images/loading_product_icon_shoe.png";

var Loading = function Loading(_ref) {
  var classsName = _ref.classsName,
      style = _ref.style;
  return _jsx("div", Object.assign({
    className: classnames(classsName, 'by-loading'),
    style: style
  }, {
    children: _jsx("div", Object.assign({
      className: "loading-container"
    }, {
      children: _jsxs("div", Object.assign({
        className: "loading-group"
      }, {
        children: [_jsx("img", {
          src: bag,
          alt: ""
        }), _jsx("img", {
          src: cloth,
          alt: ""
        }), _jsx("img", {
          src: cos,
          alt: ""
        }), _jsx("img", {
          src: shoe,
          alt: ""
        })]
      }))
    }))
  }));
};

export default Loading;